import { DateTime } from "luxon";
import { ReactElement } from "react";

import DateRangePicker, { DateRange } from "../forms/DateRangePicker";

export default (props: {
  value: DateRange;
  onChange: (newValue: DateRange) => void;
}): ReactElement => {
  // Usage always uses PT for days since that's how we handle billing
  const timezone = "America/Los_Angeles";
  const now = DateTime.now().setZone(timezone);

  return (
    <DateRangePicker
      {...props}
      shortcuts={[
        {
          title: "This Month",
          value: {
            startDate: now.startOf("month"),
            endDate: now.endOf("month"),
          },
        },
        {
          title: "Last Month",
          value: {
            startDate: now.minus({ months: 1 }).startOf("month"),
            endDate: now.minus({ months: 1 }).endOf("month"),
          },
        },
      ]}
      maxDate={now.endOf("month")}
      secondary
    />
  );
};
